const getDiffClass = (diff, invert) => {
  let normalizedValue = typeof diff === 'string'
    ? parseFloat(diff.replace(',', '.'))
    : diff;

  if (normalizedValue === 0) {
    return '';
  }

  if (invert) {
    normalizedValue *= -1;
  }

  if (normalizedValue > 0) {
    return 'positive';
  }

  if (normalizedValue < 0) {
    return 'negative';
  }

  return '';
};

export default getDiffClass;
